import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PrintLabelsSheet } from "./PrintLabelsSheet";
import { useSheetPrinter } from "./useSheetPrinter";

// SCAN A RACK OR HOLDER → PRINT LABELS (his call, 22 Oct): the screen a scan lands on gets the same one sheet.
// A level opens its rack on that one spot; a slot opens its holder on that one slot. `button` draws the
// screen's own kind of button: ({ onClick, label }) => <...>.
export function PrintLabelsLauncher({ locId, button }) {
  const { has } = useAuth();
  const can = has("generate_print_labels");
  const [target, setTarget] = useState(null);
  const [open, setOpen] = useState(false);
  const { printSheet, printDialogs } = useSheetPrinter();

  useEffect(() => {
    if (!can || !locId) return undefined;
    let live = true;
    api.get("/places/labels/start", { params: { loc_id: locId } })
      .then(({ data }) => live && setTarget(data.node ? data : null)).catch(() => live && setTarget(null));
    return () => { live = false; };
  }, [can, locId]);

  if (!target) return null;
  return (
    <>
      {button({ onClick: () => setOpen(true), label: "Print labels" })}
      {open && <PrintLabelsSheet target={target} onClose={() => setOpen(false)}
        onPrint={(data, title) => { setOpen(false); printSheet(data, title); }} />}
      {printDialogs}
    </>
  );
}
